import { compose, propOr, sortBy, toLower } from 'ramda';

export const sortByNameCaseInsensitive = (type) => sortBy(compose(toLower, propOr('', type)));
